"use client";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { useEffect, useState } from 'react';

export default function Identity(props: {
    identity: string
}) {
    const [fpHash, setFpHash] = useState<string>('');
    const [identity, setIdentity] = useState<string>(props.identity);
    const [locationHash, setLocationHash] = useState<string>('');

    useEffect(() => {
        const setFp = async () => {
            const fp = await FingerprintJS.load();
            const {visitorId} = await fp.get();
            setFpHash(visitorId);
        }

        setFp();

        const identityKey = 'adbeat_login_identity';
        let id: string = window.localStorage.getItem(identityKey) || '';
        if (id === null || id === '{{ identity }}') {
            id = identity.toString();
            window.localStorage.setItem(identityKey, id);
        }
        setIdentity(id);
        setLocationHash(window.location.hash);
    }, [identity]);

    return (
        <>
            <input type="hidden" defaultValue={fpHash} name="fingerprint" id="fingerprint" />
            <input type="hidden" defaultValue={identity} name="identity" id="identity" />
            <input type="hidden" defaultValue={props.identity} name="identity_prime" id="identity_prime" />
            <input type="hidden" defaultValue={locationHash} name="fragment" id="fragment" />
        </>
    );
};